/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect } from "react";
import { useCustomer } from "~/context";
import { ROUTES } from "~/routing/routes";
import { useGetCloudAccounts } from "~/views/accounts/hooks/useGetCloudAccounts/useGetCloudAccounts";
import { DataBox } from "../DataBox/DataBox";

export function AccountsCard() {
  const { customer } = useCustomer();

  const { count, refetch } = useGetCloudAccounts({
    page: "1",
    limit: "1",
  });

  useEffect(() => {
    refetch();
  }, [customer, refetch]);

  return (
    <DataBox
      icon="cloud"
      title="Cloud Accounts"
      value={count}
      iconLink={ROUTES.accounts.index}
    />
  );
}
